import { ROOT_PATH } from "../Constants/GlobalConstant";
import { DOCUMENTATION_MENU_TAG } from "../Navigation/SideBar/SideBarDocumentationMenu";

import yamljs from "yamljs";
import * as GenericFetch from "../../middleware/Request/GenericFetch";
import * as DocumentationUtils from "./DocumentationUtils";
import $ from "jquery";

import LogService from "../../middleware/CommonSdk/LogService";

export { isDocumentationPath, isStsDocumentation, isLtsDocumentation } from "./DocumentationUtils";
export { debounce } from "./DebounceUtils";

const LOG_TAG = "SIDEBAR_UTILS";

const getIcon = (val) => {
    switch (val.toLowerCase()) {
        case "general":
            return "book";
        case "web":
            return "desktop";
        case "ios":
            return "apple";
        case "android":
            return "android";
        case "csharp":
            return "laptop";
        case "node":
            return "server";
        case "apis":
            return "cogs";
        case "react native":
            return "tablet-alt";
        default:
            return "book";
    }
}

const formatFirstSubMenuTitle = (title, content, to = "") => {
    let obj = {};

    if (title && typeof title === "string") {
        if (title.endsWith("Advanced guides")) {
            obj = { label: title, content: content };
        } else if (title.endsWith("GUIDES")) {
            obj = { label: "Guides", content: content };
        } else if (title.endsWith("APIs")) {
            obj = { label: "API", content: content };
        } else if (to.length > 0) {
            obj = { label: title, content: content, to: to };
        } else {
            obj = { label: title, content: content };
        }
    }
    return obj;
}

const formatItem = (title, value) => {
    let obj = {};

    if (typeof value === "string" && value !== null) {
        let addExternal = false;
        let destination = "";

        if (value.startsWith("link:")) {
            addExternal = true;
            destination = DocumentationUtils.removeProtocolAndFileExtensionFromUri(value, false);
        } else if (DocumentationUtils.hasFileExtensionInUri(value, DocumentationUtils.XmlFileExtension)) {
            addExternal = true;
            destination = value;
        } else if (DocumentationUtils.hasFileExtensionInUri(value, DocumentationUtils.MdFileExtension)) {
            destination = ROOT_PATH + DocumentationUtils.removeProtocolAndFileExtensionFromUri(value, true);
        } else {
            destination = value;
        }

        obj = { label: title, to: destination };
        if (addExternal) {
            obj = { ...obj, externalLink: true }
        }
    }

    return obj;
}

const ymlToObject = (filePath) => {
    LogService.trace(LOG_TAG, "ymlToObject", "filepath:", filePath);

    if (filePath && typeof filePath === "string" && DocumentationUtils.hasFileExtensionInUri(filePath, DocumentationUtils.YmlFileExtension)) {
        let needFetchVersionFile = Promise.resolve();
        if (DocumentationUtils.isStsDocumentation(filePath)) {
            const versionFilePath = DocumentationUtils.getVersionFileUrl(filePath);
            needFetchVersionFile = GenericFetch.fetchFile(versionFilePath)
                .catch((errorPayload) => {
                    LogService.warn(LOG_TAG, "ymlToObject failed:", filePath, " version file:", errorPayload.errorMessage);
                    return Promise.resolve();
                });
        }
        return needFetchVersionFile
            .then((versionContent) => {
                let isBeta = false;
                if (versionContent && versionContent[DocumentationUtils.DocumentationType.LtsBeta]) {
                    isBeta = true;
                }

                return GenericFetch.fetchFile("/" + filePath)
                    .then((fileContent) => {
                        let result = [];
                        let ymlObj = yamljs.parse(fileContent);
                        if (ymlObj && typeof ymlObj === "object") {
                            result = browseObject(ymlObj, isBeta);
                        }
                        return Promise.resolve(result);
                    });
            })
            .catch((errorPayload) => {
                LogService.warn(LOG_TAG, "ymlToObject failed:", filePath, " error:", errorPayload.errorMessage);
                return Promise.resolve([]);
            });

    } else {
        LogService.error(LOG_TAG, "ymlToObject bad filemane skip.");
        return Promise.resolve([]);
    }
}

const browseObject = (obj, isBeta = false) => {
    let content = [];
    obj.forEach(element => {
        let title = Object.keys(element)[0];
        let value = element[title];

        if (value && typeof value === "string") {
            if (typeof element === "string" && DocumentationUtils.hasFileExtensionInUri(element, DocumentationUtils.YmlFileExtension)) {
                //LogService.log(name, "browseObject", "");
            } else {
                content.push(formatItem(title, value));
            }
        } else {
            let subcontent = [];

            value.forEach(subElement => {
                let subtitle = Object.keys(subElement)[0];
                let subvalue = subElement[subtitle];

                if (isBeta) {
                    subvalue = DocumentationUtils.addBetaToUri(subvalue);
                }
                subcontent.push(formatItem(subtitle, subvalue));//ici SDK
            });

            content.push({ ...formatFirstSubMenuTitle(title, subcontent, ""), isBeta: isBeta });
        }
    });

    return content;
}

const createSubMenu = (menuEntry) => {
    let promiseArray = [];
    if (menuEntry) {
        menuEntry.forEach(element => {
            let subtitle = Object.keys(element)[0];
            let subvalue = element[subtitle];

            if (typeof element === "string" && DocumentationUtils.hasFileExtensionInUri(element, DocumentationUtils.YmlFileExtension)) {
                let filename = DocumentationUtils.removeProtocolAndFileExtensionFromUri(element, false);
                promiseArray.push(ymlToObject(filename) //sdk, cli yml files
                    .then((subcontent) => {
                        return Promise.resolve(subcontent);
                    })
                );
            } else if (subvalue && typeof subvalue === "object") {
                if (typeof subvalue[0] === "string" && DocumentationUtils.hasFileExtensionInUri(subvalue[0], DocumentationUtils.YmlFileExtension)) {//csharp, s2s yml file
                    let filename = DocumentationUtils.removeProtocolAndFileExtensionFromUri(subvalue[0], false);
                    promiseArray.push(ymlToObject(filename)
                        .then((subcontent) => {
                            let isBeta = false;
                            let subMenu = subcontent;
                            if (subcontent) {
                                subMenu = subcontent.map((item) => {
                                    if (item.isBeta) {
                                        isBeta = true;
                                    }
                                    return item;
                                })
                            }
                            return Promise.resolve([{ ...formatFirstSubMenuTitle(subtitle, subMenu, ""), isChildBeta: isBeta }]);
                        })
                    );
                } else {//general, rest
                    let subcontent = browseObject(subvalue);
                    promiseArray.push(Promise.resolve([formatFirstSubMenuTitle(subtitle, subcontent)]));
                }
            } else if (subtitle && subvalue && typeof subvalue === "string") { // entry with no submenu and link (home of each sdk)
                promiseArray.push(Promise.resolve([formatFirstSubMenuTitle(subtitle, [], subvalue)]));
            } else if (subtitle) { // entry with no submenu
                promiseArray.push(Promise.resolve([formatFirstSubMenuTitle(subtitle, [])]));
            }
        });
    }

    return Promise.allSettled(promiseArray)
        .then((results) => {
            const subMenu = [];
            let isBeta = false;
            results.forEach((result, i) => {
                if (result.status === "fulfilled" && result.value) {
                    result.value.forEach((item) => {
                        subMenu.push(item);
                        if (item.isBeta || item.isChildBeta) {
                            isBeta = true;
                        }
                    })
                }
            });
            return Promise.resolve({
                isChildBeta: isBeta,
                content: subMenu
            });
        });
}

export const getContent = (ymlFileIndex) => {
    const promiseArray = [];
    if (ymlFileIndex?.sidebar) {
        ymlFileIndex.sidebar.forEach(doc => {
            let key = Object.keys(doc)[0];
            let value = doc[key];

            promiseArray.push(createSubMenu(value)
                .then((menuItem) => {
                    let ico = getIcon(key);
                    return Promise.resolve({ label: key, icon: ico, content: menuItem.content, isChildBeta: menuItem.isChildBeta });
                }));
        });
    }

    return Promise.allSettled(promiseArray)
        .then((results) => {
            const menu = [];
            results.forEach((result, i) => {
                if (result.status === "fulfilled") {
                    menu.push(result.value);
                }
            });
            return Promise.resolve(menu);
        });
}

export const findDocumentationPathInMenu = (documentationPath) => {
    const sideBarParentElements = $("a[class*='sidebar']")
        .filter(function () {
            const regex = new RegExp(documentationPath + "(\\?.*)?$", "gi");//match exact path and with ?isBeta or ?search_value...
            return this.href.match(regex);
        })
        .parentsUntil("#" + DOCUMENTATION_MENU_TAG);
    return sideBarParentElements;
}
